import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SwiperModule } from 'swiper/angular';
import { SeatsioModule } from '../../components/seatsio/seatsio.module';
import { MapPlaceModule } from '../../components/map-place/map-place.module';
import { FormsModule } from '@angular/forms';
import { QtyModule } from '../../components/qty/qty.module';
import { EventRoutingModule } from './event-routing.module';
import { EventComponent } from './event.component';
import { FilterModule } from 'src/app/pipes/filter/filter.module';
import { TicketHoldersModule } from '../../dialogs/ticket-holders/ticket-holders.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerModule } from '../../components/spinner/spinner.module';
import { SortByModule } from 'src/app/pipes/sort-by/sort-by.module';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { FormPorscheEventModule } from '../../components/form-porsche-event/form-porsche-event.module'
import { MapV2Module } from '../../components/mapv2/mapv2.module';
import { IsOnlyOneTicketByCustomer } from './pipes/IsOnlyOneTicketByCustomer.pipe';
import { CountdownModule } from '../../components/countdown/countdown.module';
const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    EventComponent,
    IsOnlyOneTicketByCustomer
  ],
  imports: [
    CommonModule,
    FormsModule,
    CountdownModule,
    SeatsioModule,
    MapPlaceModule,
    EventRoutingModule,
    SwiperModule,
    FormPorscheEventModule,
    NgxMaskModule.forRoot(maskConfig),
    ReactiveFormsModule,
    SpinnerModule,
    NgxSkeletonLoaderModule,
    QtyModule,
    FilterModule,
    TicketHoldersModule,
    ModalModule.forRoot(),
    SortByModule,
    MapV2Module
  ],
  exports: [
    EventComponent
  ]
})
export class EventModule { }
